import { render } from "./WeekHeader.vue?vue&type=template&id=6b7157e8"
import script from "./WeekHeader.vue?vue&type=script&lang=js"
export * from "./WeekHeader.vue?vue&type=script&lang=js"

import "./WeekHeader.vue?vue&type=style&index=0&id=6b7157e8&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__